import { useMutation, useQueryClient } from '@tanstack/react-query';

import { AssistantApi } from '../../apis';
import { Conversation } from '../../models/assistant';
import { CONVERSATION_QUERY_KEY } from './use-conversation';

const useRestartConversation = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: () => AssistantApi.restart(),
    onSuccess: () => {
      queryClient.setQueryData<Conversation>(CONVERSATION_QUERY_KEY, {
        title: null,
        messages: [],
      });
    },
  });

  return {
    restart: mutation.mutateAsync,
    isRestarting: mutation.isPending,
  };
};

export default useRestartConversation;
